<!-- Create Call (Salesforce) -->
<form [formGroup]="formGroup">
  <div class="row-wrapper">
    <h3>Create Call</h3>
    <div class="input-row">
      <div class="input-label">Call Action</div>
      <div formGroupName="properties">
        <div formGroupName="fields">
          <input type="text" formControlName="action" />
        </div>
      </div>
    </div>
    <div class="input-row">
      <div class="input-label">Comments</div>
        <span class="message tip">
          <mat-icon fontIcon="info"></mat-icon>
          @if (isDocusignAction) {
            This will include a link to the Docusign envelope
          } @else {
            This will include document details including where it has been saved
          }
        </span>
    </div>
    <mat-icon
      class="remove"
      fontIcon="close"
      [matTooltip]="'Remove action'"
      matTooltipShowDelay="500"
      (click)="removeAction()"
      (keydown.enter)="removeAction()"
      (keydown.space)="removeAction()"
      tabindex="0"
    >
    </mat-icon>
  </div>
</form>

